import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DatePicker, DefaultButton, Panel, PrimaryButton, SpinButton, Stack, Toggle} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import {dbDate} from "../../Utilities/dbDate";
import NetGrossPicker from "../../Components/NetGrossPicker";

function EditProjectAddon(props) {
    const [user] = useContext(AuthContext);
    const [netTotal, setNetTotal] = useState(0);
    const [grossTotal, setGrossTotal] = useState(0);
    const [vat, setVat] = useState(0);
    const [netCost, setNetCost] = useState(0);
    const [grossCost, setGrossCost] = useState(0);
    const [quantity, setQuantity] = useState(1);
    const [deadline, setDeadline] = useState(null);
    const [internal, setInternal] = useState(false);
    const [included, setIncluded] = useState(false);
    const [ownCost, setOwnCost] = useState(false);

    const _submit = (e) => {
        e.preventDefault();
        const data = {net_total: netTotal, gross_total: grossTotal, vat: vat, deadline: dbDate(deadline), quantity: quantity, internal: internal, net_cost: netCost, gross_cost: grossCost, ownCost: ownCost};
        fetch(`/api/project/${props.edit.project_id}/addon/${props.edit.id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    useEffect(() => {
        setQuantity(props.edit.quantity);
        setInternal(props.edit.internal);
        setDeadline(props.edit.deadline !== null ? new Date(props.edit.deadline) : null);
        setIncluded(props.edit.deadline === null);
        setNetCost(props.edit.net_cost);
        setGrossCost(props.edit.gross_cost);
        setVat(props.edit.vat);
    }, [props.edit])

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='EditProjectAddon'>Edytuj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    useEffect(() => {
        if (quantity !== props.edit.quantity) {
            setGrossTotal(quantity * (props.edit?.base_gross_price ?? 0));
            setNetTotal(quantity * (props.edit?.base_net_price ?? 0));
        } else {
            setGrossTotal(props.edit.gross_total);
            setNetTotal(props.edit.net_total);
        }
    }, [quantity, props.edit]);

    useEffect(() => {
        if (included) {
            setDeadline(null);
        }
    }, [included]);

    useEffect(() => {
        if (internal) {
            setIncluded(true);
        }
    }, [internal]);

    return (
        <Panel
            isOpen={props.edit}
            onDismiss={props.dismissPanel}
            headerText={`Edytuj Dodatek ${props.edit.addon}`}
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='EditProjectAddon'>
                <SpinButton
                    label={'Ilość:'}
                    labelPosition={'top'}
                    min={0}
                    max={1000000}
                    step={0.01}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value || '')}
                />
                <h3>Cena Bazowa: {props.edit.base_net_price ?? 0} Netto, {props.edit.base_vat}% VAT, {props.edit.base_gross_price ?? 0} Brutto</h3>
                <NetGrossPicker net={netTotal} setNet={setNetTotal} gross={grossTotal} setGross={setGrossTotal}
                                vat={vat} setVat={setVat} prefix={'Cena Razem '} />
                <Toggle label="Zawarty w umowie" checked={included} onText="Tak" offText="Nie"
                        onChange={(e, checked) => setIncluded(checked)} />
                <DatePicker
                    disabled={included}
                    label="Termin Płatności"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={deadline}
                    onSelectDate={(e) => setDeadline(e || '')}
                />
                <Toggle checked={internal} label="Wewnętrzny (płaci firma)" onText="Tak" offText="Nie"
                        onChange={(e, checked) => setInternal(checked)} />
                <Toggle checked={ownCost} label="Koszt Indywidualny" onText="Tak" offText="Nie"
                        onChange={(e, checked) => setOwnCost(checked)} />
                <NetGrossPicker net={netCost} setNet={setNetCost} gross={grossCost} setGross={setGrossCost} vat={vat} setVat={setVat} hideVat={true} prefix={'Koszt [szt] '}/>
            </form>
        </Panel>
    )
}

export default EditProjectAddon;